module.exports = __webpack_public_path__ + "16f02334f6211d1ec08c8d61148ddeaf.pdf";